import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { contextapi } from "./helpers/contextapi";
import Modal from "react-modal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./helpers/ProtectedRoute";
import Referee from "./pages/Referee";
import BioData from "./pages/BioData";
import NewApplication from "./pages/NewApplication";
import PayFee from "./pages/PayFee";
import Print from "./pages/Print";
import AdmissionLetter from "./pages/Admission/AdmissionLetter";
import Activate from "./pages/Activate";
import Forogt from "./pages/Forgot";
import OLevel from "./pages/OLevel";
import ALevel from "./pages/ALevel";
import Verify from "./pages/Verify";
import Admission from "./pages/Admission";
import Acceptance from "./pages/Acceptance";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import OLevelResult from "./pages/OLevelResult";
import AcceptanceReceipt from "./pages/Acceptance/AcceptanceReceipt";
import ApplicationReceipt from "./pages/PayFee/ApplicationReceipt";
import AcceptanceLetter from "./pages/AcceptanceLetter";
import Photo from "./pages/Photo";

const App = () => {
  const [values, setvalues] = React.useState([]);
  Modal.setAppElement("#root");
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <contextapi.Provider value={{ values, setvalues }}>
        <Router>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/forgot" element={<Forogt />} />
            <Route path="/account" element={<Register />} />
            <Route path="/letter/:id" element={<AdmissionLetter />} />
            <Route path="/activate/:id" element={<Activate />} />
            {/* <Route path="/verify-payment/:id" element={<Letter />} /> */}
            <Route path="/register" element={<Register />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/print/:id" element={<Print />} />
            <Route path="/print-acceptance/:id" element={<AcceptanceReceipt />} />
            <Route path="/acceptance_letter/:id" element={<AcceptanceLetter />} />
            <Route path="/application-receipt/:id" element={<ApplicationReceipt />} />
            <Route path={"/app/"} element={<ProtectedRoute />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="admission" element={<Admission />} />
              <Route path="accept" element={<Acceptance />} />
              <Route path="olevel" element={<OLevel />} />
              <Route path="olevelresult" element={<OLevelResult />} />
              <Route path="parents" element={<Referee />} />
              <Route path="alevel" element={<ALevel />} />
              <Route path="pay" element={<PayFee />} />
              <Route path="bio" element={<BioData />} />
              <Route path="photo" element={<Photo />} />
              <Route path="start" element={<NewApplication />} />
            </Route>
          </Routes>
        </Router>
        <ToastContainer />
      </contextapi.Provider>
    </QueryClientProvider>
  );
};

export default App;
